'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportTransform = reportTransform;
exports.transformOrderHistory = transformOrderHistory;

var _draftJs = require('draft-js');

var _draftJsExportHtml = require('draft-js-export-html');

function reportTransform(report) {

	for (var i = 0; i < report.components.length; i++) {

		if (report.components[i].type == 'text') {
			// Convert text to html
			report.components[i].data = (0, _draftJsExportHtml.stateToHTML)((0, _draftJs.convertFromRaw)(report.components[i].editorState));
		}
	}
	return report;
}

function transformOrderHistory(data) {
	return data;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/RWI/helpers.js
// module id = 558
// module chunks = 0